import React from "react";
import HeroSectionAbout from "../Components/HeroSectionAbout";
import AboutSection from "../Components/AboutSection";
import TeamSection from "../Components/TeamSection";

function About() {
  return (
    <div className="">
      <HeroSectionAbout />
      <AboutSection />
      <TeamSection />
    </div>
  );
}

export default About;
